import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const LookupActionsCell = ({ lookup, onEdit, onDelete }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", width: "100%", margin: "0 auto" }}>
      <button
        type="button"
        style={{
          background: "#2563eb",
          backgroundColor: "#2563eb",
          color: "#ffffff",
          border: "none",
          borderRadius: "6px",
          width: "32px",
          height: "32px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          padding: 0,
          flexShrink: 0
        }}
        onClick={() => onEdit(lookup)}
        title="Edit Lookup"
      >
        <FaEdit size={14} color="#ffffff" />
      </button>

      <button
        type="button"
        style={{
          background: "#dc2626",
          backgroundColor: "#dc2626",
          color: "#ffffff",
          border: "none",
          borderRadius: "6px",
          width: "32px",
          height: "32px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          padding: 0,
          flexShrink: 0
        }}
        onClick={() => onDelete(lookup.lookupGroup)}
        title="Delete Lookup"
      >
        <FaTrash size={14} color="#ffffff" />
      </button>
    </div>
  );
};

export default LookupActionsCell;
